import React from 'react';
import {
  Button,
  Header,
  Label,
  Progress,
  Segment,
  Table,
} from 'semantic-ui-react';
import {
  formatCount,
  formatPercent,
  formatTimestamp,
  statusColor,
} from './utils';

const requestTypeLabel = (requestType) => {
  const config = {
    text: ['文本', 'blue'],
    image: ['图片', 'purple'],
    video: ['视频', 'teal'],
  }[requestType] || [requestType || '未知', 'grey'];
  return (
    <Label basic color={config[1]}>
      {config[0]}
    </Label>
  );
};

const changeText = (row) => {
  if (row.is_new) return <Label color='red'>新增异常</Label>;
  if (row.change_percent === null || row.change_percent === undefined)
    return '—';
  const value = Number(row.change_percent);
  const color = value > 0 ? '#db2828' : value < 0 ? '#21ba45' : '#767676';
  return (
    <span style={{ color }}>
      {value > 0 ? '+' : ''}
      {value.toFixed(1)}%
    </span>
  );
};

const FailureTable = ({ rows, onDrillDown }) => (
  <Segment className='error-stats-panel'>
    <Header as='h3'>
      Top 失败组合
      <Header.Subheader>
        按“请求类型 + HTTP 状态码 + 失败码”归类，点击可定位明细
      </Header.Subheader>
    </Header>
    <div className='error-stats-table-wrap'>
      <Table compact selectable striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>排名</Table.HeaderCell>
            <Table.HeaderCell>请求类型</Table.HeaderCell>
            <Table.HeaderCell>状态码</Table.HeaderCell>
            <Table.HeaderCell>失败码</Table.HeaderCell>
            <Table.HeaderCell>次数 / 占比</Table.HeaderCell>
            <Table.HeaderCell>较上期</Table.HeaderCell>
            <Table.HeaderCell>最近发生</Table.HeaderCell>
            <Table.HeaderCell>操作</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {(rows || []).map((row, index) => (
            <Table.Row
              key={`${row.request_type}-${row.status_code}-${row.failure_code}`}
            >
              <Table.Cell>{index + 1}</Table.Cell>
              <Table.Cell>{requestTypeLabel(row.request_type)}</Table.Cell>
              <Table.Cell>
                <Label basic color={statusColor(row.status_code)}>
                  {row.status_code}
                  {row.status_code >= 200 && row.status_code < 300
                    ? ' 业务失败'
                    : ''}
                </Label>
              </Table.Cell>
              <Table.Cell>
                <code>{row.failure_code || 'unknown'}</code>
              </Table.Cell>
              <Table.Cell className='error-count-cell'>
                <strong>{formatCount(row.failure_count)}</strong>
                <Progress
                  percent={Math.min(100, Number(row.share_percent || 0))}
                  size='tiny'
                  color='red'
                />
                <span>{formatPercent(row.share_percent)}</span>
              </Table.Cell>
              <Table.Cell>{changeText(row)}</Table.Cell>
              <Table.Cell>{formatTimestamp(row.latest_at)}</Table.Cell>
              <Table.Cell>
                <Button
                  size='mini'
                  basic
                  primary
                  onClick={() => onDrillDown(row)}
                >
                  查看明细
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
          {(!rows || rows.length === 0) && (
            <Table.Row>
              <Table.Cell colSpan='8' textAlign='center'>
                当前筛选范围没有失败记录
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </div>
  </Segment>
);

export default FailureTable;
